exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".filestack-uploader-container {\n  padding-top: 20px; }\n  .filestack-uploader-container[aria-disabled=\"true\"] {\n    cursor: not-allowed !important;\n    opacity: 0.5; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/css-loader!/root/social-native/socialnative-web/node_modules/postcss-loader/src??ref--4-2!/root/social-native/socialnative-web/node_modules/sass-loader/lib/loader.js!../scss/filestack_uploader.scss
// module id = 3592
// module chunks = 69